import { Box, CircularProgress, Paper, Typography, useTheme } from "@material-ui/core";
import { useMemo } from "react";
import AuthorizationButton from "src/components/Button/AuthorizationButton";
import { useUserContext } from "src/context/config/userContext";
import { useWeb3Connect } from "src/wallet-connection/context/we3-connect-context";
import TitleTypography from "../Typography/TitleTypography";

export default function AuthorizationWrapper({ children, isOnlyAdmin = false }) {
  const { role, roleLoading } = useUserContext();
  const { address } = useWeb3Connect();
  const theme = useTheme();

  return (
    <Box>
      {useMemo(() => {
        if (address) {
          if (roleLoading)
            return (
              <Box width="100%" display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
              </Box>
            );
          const _check = isOnlyAdmin ? role == "admin" : role;
          if (_check) {
            return <>{children}</>;
          } else
            return (
              <Paper
                width="100%"
                display="flex"
                justifyContent="center"
                style={{ padding: "30px 20px", marginTop: 10 }}
                square
                elevation={0}
              >
                <Typography variant="body1" style={{ marginBottom: 16, color: theme.palette.text.disabled }}>
                  To protect your data from others, please generate your secure token to authenticate!
                </Typography>
                <AuthorizationButton variant="contained" color="primary" />
              </Paper>
            );
        } else
          return (
            <Paper>
              <TitleTypography textProps={{ variant: "h5" }} title="Please your wallet first!" p={1} />
            </Paper>
          );
      }, [role, address, children, isOnlyAdmin, roleLoading])}
    </Box>
  );
}
